import {
  PolicyContainer,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";

const MomsClassPrivacy = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyText>
        ㈜커넥트아이(이하“회사”)의 열달후에 맘다해 산모교실 서비스(이하
        “산모교실”)를 이용해 주셔서 감사합니다. 회사는 보다 풍성하고 유익한
        산모교실을 만들기 위해 행사 기획 및 운영 전문 마케팅 기업과 산모교실의
        준비 및 진행을 함께하고 있으며, 관련 법령에 따라 개인정보 제3자 제공
        동의를 받고 있습니다.
      </PolicyText>
      <PolicyText>
        산모교실 응모자 추첨 및 당첨자 발표를 위해 반드시 필요한 개인정보를
        다음과 같은 목적을 위하여 처리합니다. 처리하는 개인정보는 다음의 목적
        이외의 용도로는 처리되지 않으며, 처리 목적과 항목이 변경되는 경우에는
        별도의 동의를 받는 등 필요한 조치를 이행할 것입니다.
      </PolicyText>
      <PolicyText>
        회사는 서비스 이용에 필요한 최소한의 개인정보만을 수집하고 있으며,
        제휴사에 제공하고 있습니다.
      </PolicyText>
      <PolicyText>
        산모교실 응모자 중 일반 추첨과 우선 추첨을 구분하여 필요한 정보만
        필수적인 동의로 처리하고 있으며, 추가 안내를 위한 필수적 항목은 제3자
        제공 이용 동의 취소 기능이 제공되지 않습니다.
      </PolicyText>

      <PolicySectionTitle>
        개인정보 제3자 제공 처리 목적 및 처리 항목
      </PolicySectionTitle>
      <PolicyArticleTitle>1. 개인정보를 제공받는 자</PolicyArticleTitle>
      <PolicyText>페이지원미디어</PolicyText>

      <PolicyArticleTitle>2. 제공하는 개인정보 항목</PolicyArticleTitle>
      <PolicyHyphenList>
        <li>
          일반 추첨 응모자: 신청자 이름, (휴대)전화번호, 거주지역, 임신주수
        </li>
        <li>
          우선 추첨 응모자: 신청자 이름, (휴대)전화번호, 거주지역, 임신주수
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        3. 개인정보를 제공받는 자의 이용목적
      </PolicyArticleTitle>
      <PolicyHyphenList>
        <li>일반 추첨 응모자: 추첨 및 당첨자 대상 산모교실 행사 안내</li>
        <li>
          우선 추첨 응모자: 사은품 발송 및 우선 추첨권 응모 안내를 위한 해피콜
          진행, 당첨자 대상 산모교실 행사 안내
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간
      </PolicyArticleTitle>
      <PolicyText>
        개인정보 수집일로부터 6개월 보존합니다. 단, 관계 법령의 규정에 의해 일정
        기간 보존이 필요한 경우에는 해당 기간만큼 보관 후 삭제합니다.
      </PolicyText>

      <PolicySectionTitle>동의를 거부하는 경우에 대한 안내</PolicySectionTitle>
      <PolicyText>
        산모교실 추첨 응모를 위한 필수적인 동의이므로, 동의를 하지 않으면 해당
        서비스를 이용하실 수 없습니다.
      </PolicyText>

      <PolicySectionTitle>동의 철회를 위한 안내</PolicySectionTitle>
      <PolicyText>
        본 동의를 하시더라도 앱 내 마이메뉴&gt;1:1문의 또는 당사
        고객센터(after10month@connect-i.co.kr)를 통해 동의를 철회하거나 안내
        목적의 연락에 대한 중단을 요청하실 수 있으며, 이 경우 산모교실 응모
        대상에서도 제외됩니다.
      </PolicyText>
    </PolicyContainer>
  );
};

export default MomsClassPrivacy;
